import styled from 'styled-components'

export const DivListServices = styled.div`
   font-family: 'Raleway', 'sans-serif';
   padding-left: 8px;
   p#title{
      font-size: 20pt;
      font-weight: bolder;
      color: rgb(207,181, 59);
   }
   p#subtitle{
      font-size: 13pt;
   }
   li{
      padding: 10px;
      font-weight: bold;
   }
`